const errorHandler = (message: string, error: any) => {
    const errText = error.response?.data?.message?.text || 'Unexpected error';
    alert(`${message}: ${errText}`);
};

export default errorHandler;